<template>
    <div class="recommend" data-cy="recommend">
        <template v-for="(item, i) in items" :key="i">
            <div class="recommend__name">{{ item.name }}</div>
            <div class="recommend__progress">
                <div class="recommendLine">
                    <span class="recommendLine__bg" />
                    <span v-if="item.progress > 0" class="recommendLine__active" :style="`width: ${item.progress}%;`"></span>
                </div>
            </div>
            <div class="recommend__count" :class="countClassName">
                {{ item.count }}
            </div>
        </template>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import RatingProgressBar from '~/models/Product/RatingProgressBar'

export default {
    props: {
        items: {
            type: Array as PropType<RatingProgressBar[]>,
            required: true,
        },
        countClassName: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss" scoped>
/*
Structure:
    .recommend(.recommend--question)
        .recommend__name
        .recommend__count(.recommend__count--silver)
*/
.recommend {
    display: grid;
    grid-template-columns: fit-content(10%) auto fit-content(10%);
    align-items: center;
    gap: 0 8px;
    line-height: 25px;

    &--question {
        grid-template-columns: fit-content(50%) auto fit-content(10%);

        .recommend__name {
            font-weight: 400;
        }
    }
}

.recommend__name {
    font-size: 14px;
    line-height: 22px;
    font-weight: 600;
}

.recommend__count {
    font-size: 14px;

    &--silver {
        color: $color-grey-extra-dark;
    }
}

.recommendLine {
    position: relative;
}

.recommendLine__bg {
    display: block;
    border: 1px solid $color-grey-dark;
    background-color: $color-grey;
    height: 12px;
    border-radius: 50px;
    width: 100%;
}

.recommendLine__active {
    display: block;
    background-color: $color-yellow;
    height: 12px;
    border-radius: 50px;
    position: absolute;
    left: 0;
    top: 0;
    border: 2px solid $color-yellow;
    min-width: 12px;
}
</style>
